import { mapAndroidKey } from './keyboardMap'

export interface KeyInfo {
  key: string
  keyCode: number
  isAltPressed: boolean
  isCtrlPressed: boolean
  isShiftPressed: boolean
  isMetaPressed: boolean
  isCapsLockOn: boolean
  isSymPressed: boolean
  isNumLockOn: boolean
  isScrollLockOn: boolean
  isFunctionPressed: boolean
  isLongPress: boolean
}

interface KeyOption {
  consumed: boolean
  onKeyDown: (info: KeyInfo) => void
}

export namespace keyboard {
  let options: KeyOption[] = []
  let timer = 0
  let initialized = false

  export function addListener(option: KeyOption) {
    options[0] = option
  }

  export function clearListener() {
    options = []
  }

  function keydown() {
    timer = Date.now()
  }

  function keyup(event: KeyboardEvent) {
    for (const { consumed, onKeyDown } of options) {
      const isSupportGetModifierState = Boolean(event.getModifierState)
      const isCapsLockOn =
        isSupportGetModifierState && event.getModifierState("CapsLock")
      const isSymPressed =
        isSupportGetModifierState && event.getModifierState("Symbol")
      const isNumLockOn =
        isSupportGetModifierState && event.getModifierState("NumLock")
      const isScrollLockOn =
        isSupportGetModifierState && event.getModifierState("ScrollLock")
      const isFunctionPressed =
        event.getModifierState && event.getModifierState("Fn")
      // const isLongPress = (Date.now() - timer) > 2 * 1000;
      const isLongPress = false
      onKeyDown({
        key: mapAndroidKey(event),
        keyCode: event.keyCode,
        isAltPressed: event.altKey,
        isCtrlPressed: event.ctrlKey,
        isShiftPressed: event.shiftKey,
        isMetaPressed: event.metaKey,
        isCapsLockOn,
        isSymPressed,
        isNumLockOn,
        isScrollLockOn,
        isFunctionPressed,
        isLongPress,
      })
      if (!consumed) break
    }
    timer = 0
  }

  export function init() {
    if (initialized) return
    // 暂时不启用longpress，本身这样实现是错的，但是android是错的，就统一为错的
    // document.addEventListener("keypress", keyup)
    document.addEventListener("keydown", keyup)
    // document.addEventListener("keyup", keyup)
    initialized = true
  }
}

// web层面的键盘也不需要取消监听，所以就直接开启监听就好了
keyboard.init()
